import { ref } from 'vue'

export function createMq(options = {}) {
  const breakpoints = options.breakpoints || { sp: 959, pc: 960 }
  const defaultBreakpoint = options.defaultBreakpoint || 'sp'
  const mq = ref(defaultBreakpoint)

  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    const query = `(min-width: ${breakpoints.pc}px)`
    const media = window.matchMedia(query)
    const update = () => {
      mq.value = media.matches ? 'pc' : 'sp'
    }
    update()
    if (media.addEventListener) {
      media.addEventListener('change', update)
    } else {
      media.addListener(update)
    }
  }

  return {
    install(app) {
      Object.defineProperty(app.config.globalProperties, '$mq', {
        get() {
          return mq.value
        }
      })
    },
    mq
  }
}
